import React, { useEffect, useState } from 'react';
import './Drawcanvas.css';
import Player from './Player.js'
import { useSelector, useDispatch } from 'react-redux'
import { updatePlayers } from './redux/gameState.js';
import { setFaker, initPlayerState, setVote } from './redux/playerState';
import { animated, useSprings, } from "react-spring";

function Players(props) {
  const gameState = useSelector((state) => state.gameState);
  const ps = useSelector((state) => state.playerState);
  const [turn, setTurn] = useState(gameState.turn);
  const [voting, setVoting] = useState(gameState.voting);
  const [socket, setSocket] = useState(props.socket);
  const [lobby, setLobby] = useState(false);

  const dispatch = useDispatch();

  const [playerSprings, playerApi] = useSprings(
    gameState.players.length,
    i => ({}),
    []
  )

  useEffect(() => {
    setLobby(props.lobby);
  }, [props.lobby]);

  useEffect(() => {
    setSocket(props.socket);
  }, [props.socket]);

  useEffect(() => {
    setTurn(gameState.turn);
  }, [gameState.players, gameState.turn]);

  useEffect(() => {
    setTurn(gameState.turn);
  }, [gameState.turn]);

  useEffect(() => {
    setVoting(gameState.voting);
  }, [gameState.voting]);

  useEffect(() => {
    if (props.playerAnim && playerApi) {
      playerApi.start(i => {
        return {
          from: {
            scale: 1,
          },
          scale: 1.1,
          reverse: true,
          delay: 800 + (i * 150),
          duration: 100,
        }
      }
      );
    }
  }, [props.playerAnim, playerApi]);

  useEffect(() => {
    socket.once("updatePlayers", updatedPlayers => {
      console.log("receiving new player list: ", updatedPlayers);
      dispatch(initPlayerState(updatedPlayers.find(p => p.id === ps.id)));
      dispatch(updatePlayers(updatedPlayers));
    });
    return () => {
      socket.off('updatePlayers');
    }
  });

  socket.once("setPlayerFaker", roomNum => {
    console.log("setting faker for", ps.id, " in room ", roomNum, " ", gameState.room)
    if (roomNum === gameState.room) {
      dispatch(setFaker(true))
    }
  });

  function vote(e, pid) {
    console.log("voting: ", voting, " ps.voted: ", ps.voted)
    if (voting && !ps.voted) {
      dispatch(setVote(pid));
      console.log("my new vote: ", pid);
    }

    return;
  }

  //alternate render for lobby view
  if (lobby) {
    return (
      <div id='playersLobby' className="playersComponent bg-gray-100 shadow shadow-2xl w-full sm:p-5 p-2 text-base text-gray-700 flex flex-col h-full">
        <p className="text-black-700 font-bold divide-y border-b-4 md:pb-2 border-indigo-700 text-center">Current players:</p>
        <div className='flex-1 relative w-full'>
          <ul className="list-none flex items-center flex-row items-stretch overflow-x-auto overflow-y-hidden h-full w-screen max-w-full"> {gameState.players.map((player, i) => (
            <li key={i}
              className="m-2 h-full min-w-max">
              <Player player={player} />
            </li>
          ))}
          </ul>
        </div>
      </div>
    );
  }
  return (
    <div id='playersGame' className="playersComponent bg-gray-100 shadow shadow-2xl w-full px-1 lg:px-4 lg:py-4 text-base text-gray-700 md:text-xl flex flex-col h-full rounded">
      <p className="flex 2xl:text-xl md:text-md text-sm text-black-700 font-bold divide-y border-b-4 pb-2 md:mb-2 border-indigo-700 justify-center">Current players:</p>
      <div className='flex justify-center mt-1'>
        {(gameState.voting) ?
          <p className="align-bottom xl:text-xl md:text-md text-sm">Select the faker and click vote!</p>
          :
          <div className='items-center justify-center w-full h-full flex'><Player player={gameState.players[turn]} /><p className="max-w-full w-3/4 xl:w-1/2 lg:text-lg text-sm">'s turn!</p></div>
        }
      </div>
      <div className='flex-1 relative w-full md:pt-1'>
        <ul className=" list-none md:px-1 md:pb-6 flex items-center flex-row md:flex-col items-stretch overflow-x-auto md:overflow-x-hidden md:overflow-y-auto overflow-y-hidden md:absolute h-full w-full"> {playerSprings.map((spring, i) => (
          // maybe place checkmark icon to show that a player has voted?
          <animated.li key={i}
            className={(gameState.voting && ps.myVote == gameState.players[i].id) ? ' m-1 rounded-lg border-solid border-2 border-blue-500 ' : " m-1 rounded-lg"}
            style={{ ...spring }}>
            <button
              disabled={!voting} onClick={(evt) => vote(evt, gameState.players[i].id)} className={'playerBtn w-full h-full rounded-lg flex truncate transform ' + (gameState.voting ? 'hover:scale-110' : '')}>
              <div className='items-center justify-center w-full h-full flex'>
                <Player player={gameState.players[i]} />
              </div>
            </button>
          </animated.li>
        ))}
        </ul>
      </div>
    </div>
  );
}

export default Players;
